module.exports = __webpack_public_path__ + "img/double-arrow.f52d2ec3.svg";